import React, {FC} from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

type Classes = {
  root?: string;
  icon?: string;
};

type Props = {
  color?: string;
  classes?: Classes;
};

const RightArrowIcon: FC<Props> = ({classes, color}) => (
  <SvgIcon className={classes?.root} width="24" height="24" viewBox="0 0 24 24">
    <path
      className={classes?.icon}
      d="M3 11H17.17L13.59 7.41L15 6L21 12L15 18L13.59 16.59L17.17 13H3V11Z"
      fill={color}
    />
  </SvgIcon>
);

export default RightArrowIcon;
